<template>
  <div class="filter-component">
    <b-container class="mb-3 mt-3">
      <b-row>
        <b-col>
          <b-form @submit.prevent="onSearch('query')">
          <b-input-group>
            <b-form-input v-model="searchText" placeholder="Search"></b-form-input>
            <b-input-group-append>
              <b-button
                :disabled="this.searchText === ''"
                class="button-search"
                type="submit"
              >
                <span class="material-icons">search</span>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form>
        </b-col>
      </b-row>
    </b-container>
    <b-container v-if="topics.length">
      <b-row class="justify-content-center">
        <b-col cols="auto" class="tags-container">
          <b-button
            v-for="topic in topics"
            :key="topic.id"
            :class="getButtonVariant(topic)"
            class="tag-button"
            @click.prevent="selectTopic(topic)"
          >
            {{ topic.name }}
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: {
    topics: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchText: '',
      searchTextCopy: '',
      selectedTopic: null,
      aSearchHasBeenPerformed : false,
    };
  },
  methods: {
    selectTopic(topic) {
      this.selectedTopic = topic.id !== this.selectedTopic ? topic.id : null;
      this.onSearch('topic');
    },
    getButtonVariant(topic) {
      return topic.id === this.selectedTopic ? 'selected-topic' : 'deselected-topic';
    },
    onSearch(type) {
      switch (type) {
        case 'topic':
          this.$emit('onSearch', { search: this.selectedTopic, type });
          break;

        default:
          if(this.searchText === this.searchTextCopy) return
          this.searchTextCopy = this.searchText
          this.$emit('onSearch', { search: this.searchText, type });
          break;
      }
      this.aSearchHasBeenPerformed = true;
    },
  },
  watch: {
    searchText(newValue, oldValue) {
      if (newValue === '' && this.aSearchHasBeenPerformed) {
        this.onSearch('query');
        this.aSearchHasBeenPerformed = false;
      }
    },
  },
};
</script>

<style scoped>
.filter-component {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 8px 18px 8px;
}

.button-search {
  padding: 0px 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-main);
}

.tags-container-wrapper {
  max-height: 200px;
  overflow-y: auto;
}

.tags-container {
  display: flex;
  overflow-y: auto;
  gap: 12px;
  padding: 10px 0px;
}

.tag-button {
  width: auto;
  white-space: nowrap;
  border-color: var(--color-main);
}

.selected-topic {
  background-color: var(--color-main);
  color: white;
}
.deselected-topic {
  background-color: white;
  color: var(--color-main);
}
</style>
